module.exports = __webpack_public_path__ + "media/images/icons/sw-comm-ae59c21b41708dbe90639bdb4f0a5c6d.svg";